import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

//Locales
const current_password_missing = i18n.t('settings.change_password.current_password_missing');
const new_password_required = i18n.t('settings.change_password.new_password_required');
const error_min_characters = i18n.t('settings.change_password.error_min_characters');
const error_min_numbers = i18n.t('settings.change_password.error_min_numbers');
const error_min_lowercase = i18n.t('settings.change_password.min_lowercase');
const error_min_uppercase = i18n.t('settings.change_password.min_uppercase');
const passwords_must_match = i18n.t('settings.change_password.passwords_must_match');
const confirmation_required = i18n.t('settings.change_password.confirmation_required');

//Schemas
const resetPasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required(current_password_missing),
  newPassword: Yup.string()
    .required(new_password_required)
    .min(8, error_min_characters)
    .matches(/(?=.*[A-Z])/, error_min_uppercase)
    .matches(/(?=.*[0-9])/, error_min_numbers)
    .matches(/(?=.*[a-z])/, error_min_lowercase),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword')], passwords_must_match)
    .required(confirmation_required)
});

//Types
export type ResetPasswordData = Yup.InferType<typeof resetPasswordSchema>;

//Resolvers
export const resetPasswordResolver = yupResolver(resetPasswordSchema);
